export default [
	{
		path: '/ssl/guide-order/:id',
		name: 'GuideOrder',
		component: () => import('@/views/ssl/guide-order.vue'),
		meta: { title: '电子检测指引单' }
	}
]
